export class OperatorModel {
    //step 1
    public CompanyName: string = '';
    public FirstName: string = '';
    public LastName: string = '';
    public FullName: string = this.FirstName + ' ' + this.LastName;
    public Email: string = '';
    public Address: string = '';
    public Birthdate: Date | undefined;
    public Gender: number = 0;
    public IsTermsAccepted: boolean = false;
    //step 2
    public TaxNumber: string = '';
    public IsCorporateAccount: boolean = false;
    public BankTypeId: number = 0;
    public AccountNumber: string = '';
    public AccountName: string = '';
    public CorporateAccountNumber: string = '';
    //docs
    public GovIdUrls: string[] = [];
    public DTIorSECCertifUrls:  string[] = [];
    public BIRCertifUrls:  string[] = [];
    public LTFRBCertifUrls:  string[] = [];
    public BusinessPermitUrls:  string[] = [];
    public GovIdData: File[] = [];
    public BIRCertifData: File[] = [];
    public BusinessPermitData: File[] = [];
    public DTIorSECCertifData: File[] = [];
    public LTFRBCertifData: File[] = [];
    //step3
    public Password: string = '';
    public ConfirmPassword: string = '';
}

export interface OperatorSignUpResponse{
    ProcessId: string;
}
